import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKanban = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .kanban-cls-2 {\n        fill: transparent;\n      }\n\n      .kanban-cls-3 {\n        fill: currentColor\n      }\n\n      .kanban-cls-4 {\n        fill: currentColor;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "kanban-cls-2",
			d: "M24.357,25H.643A.643.643,0,0,1,0,24.357V.643A.643.643,0,0,1,.643,0H24.357A.643.643,0,0,1,25,.643V24.357A.643.643,0,0,1,24.357,25Z"
		}) }),
		/* @__PURE__ */ _jsx("path", {
			className: "kanban-cls-3",
			d: "M24.357,0H.643A.643.643,0,0,0,0,.643V24.357A.643.643,0,0,0,.643,25H8.117V23.714H1.286V1.286H23.714V23.714H16.883V25h7.474A.643.643,0,0,0,25,24.357V.643A.643.643,0,0,0,24.357,0Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "kanban-cls-4",
			x: 5.522,
			y: 5.522,
			width: 2.594,
			height: 13.956
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "kanban-cls-4",
			x: 11.203,
			y: 5.522,
			width: 2.594,
			height: 19.478
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "kanban-cls-4",
			x: 16.883,
			y: 5.522,
			width: 2.594,
			height: 15.67
		})
	]
});
export default SvgKanban;
